import React, { useState } from 'react';
import { Table, Button, Modal, Form, Card, Row, Col, InputGroup } from 'react-bootstrap';
import { FaEye, FaSearch, FaCheck, FaDownload, FaExclamationTriangle } from 'react-icons/fa';
import FirmaPad from '../components/FirmasPad';
import DescargaRecibo from '../components/Descrecibos';
import ReclamoForm from '../components/reclamoRecibo';
import ResolucionModal from '../components/ResolucionModal';
import ConfirmModal from '../components/ConfirmModal';
// import 'bootstrap/dist/css/bootstrap.min.css'; // Importar solo en index.js/main.jsx
import '../styles/recibos.css';

const ENCUESTA_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSdmiodwkWKAhj_UFj2w6Jz47nm1x4iOyNuxLAim7FPwE_lzBg/viewform?usp=sharing&ouid=117695010889760431703';

// Ejemplo: queremos exigir encuesta para todos los recibos cuyo mes sea 10 (octubre)
const MES_ENCUESTA = 11;

const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'development' ? 'http://localhost:4004' : 'https://colaboradores.sibus.com.ar');

const Recibos = ({ recibos, userLegajo, userName, refetchRecibos }) => {
  const [mostrarFirma, setMostrarFirma] = useState(false);
  const [reciboParaFirma, setReciboParaFirma] = useState(null);
  const [reciboParaReclamo, setReciboParaReclamo] = useState(null);
  const [datosReciboActual, setDatosReciboActual] = useState(null);
  const [filtroMes, setFiltroMes] = useState('');
  const [mostrarResolucion, setMostrarResolucion] = useState(false);
  const [resolucionActual, setResolucionActual] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  // Encuesta clima laboral
  const [showEncuestaModal, setShowEncuestaModal] = useState(false);
  const [reciboPendienteEncuesta, setReciboPendienteEncuesta] = useState(null);

  // --------------------------------------------------------------------------------
  // Helpers de fechas / meses
  // --------------------------------------------------------------------------------
  const parseMes = (mesStr) => {
    const [mes, anio] = mesStr.split('/').map(Number);
    return { mes, anio };
  };

  const requiereEncuestaParaRecibo = (recibo) => {
    const { mes } = parseMes(recibo.Mes);
    return mes === MES_ENCUESTA;
  };

  // --------------------------------------------------------------------------------
  // Selección de recibo para firma (flujo normal, sin encuesta)
  // --------------------------------------------------------------------------------
  const handleSeleccion = async (recibo) => {
    const [mes, anio] = recibo.Mes.split('/');
    const legajoFormateado = userLegajo.toString().padStart(4, '0');
    const secuencia = recibo.Secuencia;
    const fileBase = `${anio}${mes}${secuencia}O${legajoFormateado}`;
    
    // Usar endpoint del backend - mes es solo el número (ej: 12)
    const normalizedAPI = API_URL.replace(/\/$/, '');
    const pdfPath = `${normalizedAPI}/api/recibos/${mes}/${secuencia}/${userLegajo}/pdf`;
    const fileName = `${fileBase}.png`;

    try {
      const token = localStorage.getItem('token');
      const res = await fetch(pdfPath, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!res.ok) {
        console.error(`PDF not found: ${pdfPath}, Status: ${res.status}`);
        return alert("El archivo PDF del recibo no está disponible.");
      }
      setReciboParaFirma(recibo);
      setDatosReciboActual({ fileName, pdfPath });
      setMostrarFirma(true);
    } catch (error) {
      console.error('Error fetching PDF:', error);
      alert("No se pudo verificar la existencia del archivo PDF.");
    }
  };

  // --------------------------------------------------------------------------------
  // Nueva lógica: antes de firmar, chequear encuesta clima
  // --------------------------------------------------------------------------------
  const handleClickFirmarRecibo = async (recibo) => {
    // Si este recibo NO requiere encuesta, seguimos como antes
    if (!requiereEncuestaParaRecibo(recibo)) {
      return handleSeleccion(recibo);
    }

    try {
      const token = localStorage.getItem('token');

      const resp = await fetch(`${API_URL}/api/Extra/encuesta-clima?CdEmpleado=${userLegajo}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // 404 → no respondió todavía
      if (resp.status === 404) {
        setReciboPendienteEncuesta(recibo);
        setShowEncuestaModal(true);
        return;
      }

      if (!resp.ok) {
        console.error('Error al consultar encuesta de clima', await resp.text());
        alert('No se pudo verificar el estado de la encuesta de clima');
        return;
      }

      const data = await resp.json();
      if (data.responded) {
        // Ya aceptó o rechazó → se permite flujo normal
        return handleSeleccion(recibo);
      }

      // Por si viniera responded: false
      setReciboPendienteEncuesta(recibo);
      setShowEncuestaModal(true);
    } catch (err) {
      console.error('Error al consultar encuesta de clima', err);
      alert('No se pudo verificar el estado de la encuesta de clima');
    }
  };

  const handleEncuestaDecision = async (accion) => {
    if (!reciboPendienteEncuesta) return;

    try {
      const usuario = JSON.parse(localStorage.getItem("user"));

      const resp = await fetch(`${API_URL}/api/Extra/encuesta-clima`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          CdEmpleado: usuario.Legajo,
          NmEmpleado: usuario.Nombre,
          Accion: accion,
        }),
      });

      const data = await resp.json();

      if (resp.status === 404 || resp.status === 500) {
        console.warn("El backend remoto aún no implementa encuesta-clima.");
        setShowEncuestaModal(false);
        await handleSeleccion(reciboPendienteEncuesta);
        setReciboPendienteEncuesta(null);
        return;
      }

      if (!resp.ok) {
        console.error("Error backend:", data);
        alert("No se pudo registrar la encuesta");
        return;
      }

      setShowEncuestaModal(false);

      if (accion === 'aceptar') {
        window.open(ENCUESTA_URL, '_blank');
      }

      await handleSeleccion(reciboPendienteEncuesta);
      setReciboPendienteEncuesta(null);

    } catch (err) {
      console.error("Error al conectar con encuesta clima:", err);
      alert("Error de conexión");
    }
  };



  // --------------------------------------------------------------------------------
  // Firma
  // --------------------------------------------------------------------------------
  const handleFirmaConfirmada = async (firmaDataUrl) => {
    if (!datosReciboActual || !reciboParaFirma) return;
    const base64 = firmaDataUrl.split(',')[1];
    const token = localStorage.getItem('token');

    const payload = {
      Mes: reciboParaFirma.Mes,
      Secuencia: reciboParaFirma.Secuencia,
      Legajo: userLegajo,
      Base64Image: base64,
    };

    try {
      const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');
      const response = await fetch(`${API_URL}/api/procesos/firmar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error('Error al subir la firma');

      localStorage.setItem('firmaEmpleado', base64);

      setMostrarFirma(false);
      setReciboParaFirma(null);
      setDatosReciboActual(null);

      await refetchRecibos();
      
      // Descargar PDF con autenticación
      try {
        const pdfResponse = await fetch(datosReciboActual.pdfPath, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (pdfResponse.ok) {
          const blob = await pdfResponse.blob();
          const url = window.URL.createObjectURL(blob);
          window.open(url, '_blank');
          setTimeout(() => window.URL.revokeObjectURL(url), 100);
        }
      } catch (err) {
        console.error('Error opening PDF:', err);
      }
    } catch {
      alert('No se pudo enviar la firma.');
    }
  };

  const handleConfirmValidation = async (recibo) => {
    setShowConfirm(false);
    await handleAceptarRecibo(recibo);
  };

  // --------------------------------------------------------------------------------
  // Validar recibo (empleado marca como conforme)
  // --------------------------------------------------------------------------------
  const handleAceptarRecibo = async (recibo) => {
    try {
      const token = localStorage.getItem('token');
      const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');

      console.log('🔍 Validando recibo:', {
        mes: recibo.Mes,
        secuencia: recibo.Secuencia,
        legajo: userLegajo
      });

      // Validar recibo
      const validationResponse = await fetch(`${API_URL}/api/procesos/validar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          mes: recibo.Mes,
          secuencia: recibo.Secuencia,
          legajo: userLegajo
        }),
      });

      if (!validationResponse.ok) {
        const errorData = await validationResponse.json();
        console.error('❌ Error validando:', errorData);
        throw new Error(errorData.error || 'Error al validar el recibo');
      }

      const resultado = await validationResponse.json();
      console.log('✅ Recibo validado:', resultado);

      // Limpiar protesta si la había
      await fetch(`${API_URL}/api/procesos/protestar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          Mes: recibo.Mes,
          Secuencia: recibo.Secuencia,
          Protesta: 0,
          ObsProt: '',
        }),
      });

      await refetchRecibos();
      alert('Recibo validado correctamente');
    } catch (error) {
      alert(error.message || 'Error al validar el recibo');
      console.error('Error completo:', error);
    }
  };

  // --------------------------------------------------------------------------------
  // Reclamo
  // --------------------------------------------------------------------------------
  const handleReclamoSuccess = async () => {
    await refetchRecibos();
  };

  // Resolución
  const handleVerResolucion = (recibo) => {
    setResolucionActual(recibo);
    setMostrarResolucion(true);
  };

  // --------------------------------------------------------------------------------
  // Filtros, orden, agrupado y bloqueo por mes anterior
  // --------------------------------------------------------------------------------
  const recibosFiltrados = recibos.filter((recibo) =>
    recibo.Mes.toLowerCase().includes(filtroMes.toLowerCase())
  );

  const recibosOrdenados = [...recibosFiltrados].sort((a, b) => {
    const { mes: mesA, anio: anioA } = parseMes(a.Mes);
    const { mes: mesB, anio: anioB } = parseMes(b.Mes);

    if (anioA !== anioB) return anioB - anioA;
    if (mesA !== mesB) return mesB - mesA;
    return b.Secuencia - a.Secuencia;
  });

  const agruparPorMes = (recibos) => {
    const map = new Map();
    for (const r of recibos) {
      if (!map.has(r.Mes)) map.set(r.Mes, []);
      map.get(r.Mes).push(r);
    }
    return Array.from(map.entries()).map(([Mes, items]) => ({ Mes, recibos: items }));
  };

  const grupos = agruparPorMes(recibosOrdenados);

  const recibosConBloqueo = [];
  for (let i = 0; i < grupos.length; i++) {
    const grupo = grupos[i];
    const recibosDelMes = grupo.recibos;
    let bloqueado = false;

    if (i < grupos.length - 1) {
      const grupoAnterior = grupos[i + 1];
      const todosValidados = grupoAnterior.recibos.every((r) => r.Valida === 1);
      if (!todosValidados) bloqueado = true;
    }

    for (const r of recibosDelMes) {
      recibosConBloqueo.push({ ...r, bloqueado });
    }
  }

  // --------------------------------------------------------------------------------
  // Render
  // --------------------------------------------------------------------------------
  return (
    <div className="container py-4 recibos-scope">
      <Card className="shadow-lg rounded-4 p-4">
        <h3 className="mb-4 text-center text-dark-emphasis">📄 Recibos de Sueldo</h3>

        <Row className="mb-4">
          <Col md={6} className="mx-auto">
            <InputGroup>
              <InputGroup.Text>
                <FaSearch />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Buscar por mes (ej: 04/2025)"
                value={filtroMes}
                onChange={(e) => setFiltroMes(e.target.value)}
              />
            </InputGroup>
          </Col>
        </Row>

        <div className="table-responsive">
          <Table hover bordered className="tabla-estilizada">
            <thead className="table-encabezado text-white">
              <tr>
                <th>#</th>
                <th>Nº Sec.</th>
                <th>Fecha</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {recibosConBloqueo.map((recibo, index) => (
                <tr
                  key={`${recibo.Mes}-${recibo.Secuencia}`}
                  className={index % 2 === 0 ? 'fila-celeste' : 'fila-blanca'}
                >
                  <td>{index + 1}</td>
                  <td>{recibo.Secuencia}</td>
                  <td>{recibo.Mes}</td>
                  <td>
                    {recibo.bloqueado ? (
                      <span className="text-muted small">
                        🔒 Debe validar el mes anterior
                      </span>
                    ) : recibo.Firmado === 1 ? (
                      <div className="actions-cell">
                        <DescargaRecibo recibo={recibo} userLegajo={userLegajo} />
                        {recibo.Valida !== 1 && (
                          <>
                            <Button
                              className="btn-validar action-btn"
                              size="sm"
                              onClick={() => setShowConfirm(true)}
                              title="Aceptar recibo"
                            >
                              <FaCheck />
                            </Button>

                            {showConfirm && (
                              <ConfirmModal
                                onConfirm={() => handleConfirmValidation(recibo)}
                                onCancel={() => setShowConfirm(false)}
                              />
                            )}

                            <Button
                              className="btn-reclamo action-btn"
                              size="sm"
                              onClick={() => setReciboParaReclamo(recibo)}
                              title="Reclamar diferencias"
                            >
                              <FaExclamationTriangle />
                            </Button>
                            {recibo.Resuelto === 1 && (
                              <Button
                                className="btn-respuesta action-btn"
                                size="sm"
                                onClick={() => handleVerResolucion(recibo)}
                                title="Ver resolución del reclamo"
                              >
                                <FaEye className="me-1" />
                              </Button>
                            )}
                          </>
                        )}
                      </div>
                    ) : (
                      <Button
                        size="sm"
                        className="btn-firmar action-btn"
                        onClick={() => handleClickFirmarRecibo(recibo)}
                        title="Firmar y descargar"
                      >
                        <FaDownload />
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Card>

      {/* Modal para firma */}
      <Modal show={mostrarFirma} onHide={() => setMostrarFirma(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Firma del Recibo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {datosReciboActual && (
            <FirmaPad
              onFirmar={handleFirmaConfirmada}
              onCancelar={() => setMostrarFirma(false)}
              fileName={datosReciboActual.fileName}
            />
          )}
        </Modal.Body>
      </Modal>

      {/* Modal para reclamo */}
      {reciboParaReclamo && (
        <ReclamoForm
          show={!!reciboParaReclamo}
          onHide={() => setReciboParaReclamo(null)}
          recibo={reciboParaReclamo}
          userLegajo={userLegajo}
          userName={userName}
          onReclamoSuccess={handleReclamoSuccess}
        />
      )}

      {/* Modal para resolución */}
      <ResolucionModal
        show={mostrarResolucion}
        onHide={() => setMostrarResolucion(false)}
        resolucion={resolucionActual}
      />

      {/* Modal Encuesta Clima Laboral */}
      <Modal show={showEncuestaModal} onHide={() => setShowEncuestaModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Encuesta de Clima Laboral</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Antes de visualizar y firmar tu recibo de sueldo de este período, te pedimos que
            indiques si aceptás completar la encuesta de clima laboral.
          </p>
          <p className="mb-0">
            Podés aceptarla ahora (se abrirá en una nueva pestaña) o rechazarla. Solo se te
            solicitará una vez.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleEncuestaDecision('rechazar')}>
            Rechazar
          </Button>
          <Button variant="primary" onClick={() => handleEncuestaDecision('aceptar')}>
            Aceptar y continuar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Recibos;
